import { render, staticRenderFns } from "./ViewPositionDraw.vue?vue&type=template&id=676ab696&scoped=true"
import script from "./ViewPositionDraw.vue?vue&type=script&lang=js"
export * from "./ViewPositionDraw.vue?vue&type=script&lang=js"
import style0 from "./ViewPositionDraw.vue?vue&type=style&index=0&id=676ab696&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676ab696",
  null
  
)

export default component.exports